import { styled } from '@mui/material/styles';

export const Logo = styled('img')`
  display: block;
  margin: auto;
  padding: 20px;
  max-height: 100px;
  max-width: 100px;
`;
